export default __webpack_public_path__ + "static/media/mexico-city.49d7e970.png";